import appReducer from "./appReducer";

export default appReducer;
